import {Part} from "../part";
import {wallsThumbnail} from "../assets";
import {PartMenuType} from "../../../visComponents/constants";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";

import Ceiling from "../subparts/walls/ceiling";
import LeftWall from "../subparts/walls/leftWall";
import RightWall from "../subparts/walls/rightWall";
import PopoutWall from "../subparts/walls/popoutWall";
import Backsplash from "../subparts/walls/backsplash";
import store from "../../../../store";

export default class Walls extends Part {
  static id = 'Walls';
  constructor() {
    super(true, false, PartMenuType.Complex);

    this.menuType = PartMenuType.Complex;
    this.partName = 'Walls';
    this.partThumbnail = wallsThumbnail;
    this.translateId = "visualizer.kitchen.walls";

    // related items
    this.leftWall = null;
    this.rightWall = null;
    this.popoutWall = null;
    this.ceiling = null;
    this.backsplash = null;
  }

  load(dbFeature) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Left Wall":
        relatedItemName = "leftWall";
        RelatedItemClass = LeftWall;
        break;
      case "Right Wall":
        relatedItemName = "rightWall";
        RelatedItemClass = RightWall;
        break;
      case "Popout Wall":
        relatedItemName = "popoutWall";
        RelatedItemClass = PopoutWall;
        break;
      case "Backsplash":
      case "backsplash":
        relatedItemName = "backsplash";
        RelatedItemClass = Backsplash;
        break;
      case "Ceiling":
        relatedItemName = "ceiling";
        RelatedItemClass = Ceiling;
        break;
      // case "Shower Shadow":
      //   if (
      //     dbFeature.displayName.includes("Shower Shadow - Divider Wall")
      //     || dbFeature.displayName.includes("Shower Shadow - EX L")
      //     || dbFeature.displayName.includes("Shower Shadow - EX R")
      //     || dbFeature.displayName.includes("Shower Shadow - Popout")
      //     || dbFeature.displayName.includes("Shower Shadow - Pony Wall")
      //   ) {
      //     relatedItemName = "shadows";
      //     RelatedItemClass = Shadow;
      //   }
      //   break;
    }
    if (relatedItemName) {
      if (!this[relatedItemName]) {
        this[relatedItemName] = new RelatedItemClass(true);
        if (relatedItemName !== "shadows") {
          this.relatedItems.push(this[relatedItemName]);
        }
      }
      if (!this.categoryEnabled) {
        this.categoryEnabled = true
      }
      this[relatedItemName].getParent = () => this;
      this[relatedItemName].load(dbFeature);
      return true
    }
    return false
  }

  navigationItem() {
    return new DesignNavigationItem('Walls', this);
  }

  isSubTypeWithItems() {
    return false;
  }

  subParts(withHidden = true) {
    return this.relatedItems
      .filter(item => {
        if (item.partId === "popout_wall") {
          item.visible = item.getParent().layout.getCurrentLayoutAbbreviation().includes("P")
        }
        return this.filterRelatedItem(item, withHidden)
      })
      .map(_ => new DesignNavigationItem(_.partName, _));
  }

  handleSubPartClick() {

  }

  recoverPrevioslySelected(activeRelatedPart) {
    const {activeQuoteIndex} = store.getState().quotesState;
    this.relatedItems.forEach(relatedItem => {
      if (relatedItem.partId !== activeRelatedPart.partId && relatedItem.activeFeatureBeforeAllWalls) {
        if (relatedItem.activeFeatureBeforeAllWalls === "placeholder") {
          relatedItem.placeholderChanged = false;
          relatedItem.firstClick[activeQuoteIndex] = false;
        } else if (!relatedItem.selectedByUser) {
          relatedItem.activeFeatureBeforeAllWalls.clickFromAllWalls();
        }
      }
    });
  }

}
